export default "__VITE_ASSET__D4rpRLsg__"